import { renderPosImage, renderPosName } from '@vgrubs/components';
import {
  OTHER_POS,
  PosChoice,
} from '../../../types/api/integrationAccess.types';

export const isOtherPos = (type: PosChoice): type is typeof OTHER_POS =>
  type === OTHER_POS;

/** Display name and logo that also cover the "I use a different POS" answer. */
export const posDisplayName = (type: PosChoice) =>
  isOtherPos(type) ? 'Other POS' : renderPosName(type, type) ?? type;

export const posImage = (type: PosChoice) =>
  isOtherPos(type) ? undefined : renderPosImage(type) || undefined;
